import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BlogEntry } from './blog-entry';
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlogBackendService {
  constructor(private http: HttpClient) { }

  public getAllEntries(): Observable<BlogEntry[]> {
    return this.http.get<BlogData>('/api/blog')
      .pipe(map(result => result!.feed!.entry));
  }
}

interface BlogData {
  feed: BlogFeed;
}

interface BlogFeed {
  entry: BlogEntry[];
}




